class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    if (facetForm) facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      var url = "";
      if (window.location.pathname.includes("search")) {
        url = `${window.location.pathname}?${searchParams}`;
      } else {
        url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      }
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html, event);
        // FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html, event);
    // FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html, event) {

    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    var urlParams = new URLSearchParams(window.location.search);
    var sortBy = urlParams.get('sort_by');

    if (sortBy) {
      FacetFiltersForm.customSorting(sortBy);
    }

    FacetFiltersForm.customFiltering();

    FacetFiltersForm.resetMiniaturesListeners();

    var productImagePicker = urlParams.get('image');
    if (productImagePicker) {
      FacetFiltersForm.slideToSwiperImageInner(productImagePicker);
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];

    sortFilterForms.forEach((form) => {
      forms.push(this.createSearchParams(form));
    });

    // add image param
    var urlParams = new URLSearchParams(window.location.search);
    var productImagePicker = urlParams.get('image');

    if (productImagePicker && (productImagePicker == 0 || productImagePicker == 1)) {
      forms.push('image=' + productImagePicker);
    }

    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    var url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    var urlParams = new URLSearchParams(window.location.search);
    var productImagePicker = urlParams.get('image');

    if (productImagePicker) {
      if (productImagePicker == 0) {
        url = url + '&image=0'
      } else if (productImagePicker == 1) {
        url = url + '&image=1'
      }
    }

    FacetFiltersForm.renderPage(url);
  }

  static customSorting(sortOption) {

    if (sortOption == "weight-ascending" || sortOption == "weight-descending") {
      // console.log("stop!");

      var products = document.querySelectorAll('.product_item');
      var productArray = Array.from(products);

      // console.log(productArray);
      productArray.sort(function (a, b) {
        var weightA = parseFloat(a.getAttribute('data-weight'));
        var weightB = parseFloat(b.getAttribute('data-weight'));

        if (sortOption === 'weight-ascending') {
          return weightA - weightB;
        } else if (sortOption === 'weight-descending') {
          return weightB - weightA;
        }
      });

      var productContainer = document.getElementById('product-grid');
      productArray.forEach(function (product) {
        productContainer.appendChild(product);
      });
    }

    // 11-11-24 comment if to show all variants of best selling products
    // if (sortOption == "best-selling") {
    //   var products = document.querySelectorAll('.product_item');
    //   var productArray = Array.from(products);
    //   // console.log(productArray);

    //   var uniqueHandles = new Set();

    //   var filteredProducts = productArray.filter(function (product) {
    //     var handle = product.getAttribute('data-handle');

    //     if (!uniqueHandles.has(handle)) {
    //       uniqueHandles.add(handle);
    //       return true;
    //     }
    //     return false;
    //   });

    //   // console.log(filteredProducts);

    //   var productContainer = document.getElementById('product-grid');

    //   productContainer.innerHTML = '';

    //   filteredProducts.forEach(function (product) {
    //     productContainer.appendChild(product);
    //   });
    // }

  }

  static customFiltering() {
    // COLOR AND SIZE FILTERING

    var productContainer = document.getElementById('product-grid');
    var products = document.querySelectorAll('.product_item');
    var productArray = Array.from(products);
    // console.log(productArray);
    var filteredProducts = [];

    var colorFilterInputs = document.querySelectorAll('input[id*="option.color"]');
    // console.log(colorFilterInputs);
    var colorFilterApplied = false;

    var sizeFilterInputs = document.querySelectorAll('input[id*="option.size"]');
    var sizeFilterApplied = false;

    var badgeFilterInputs = document.querySelectorAll('input[id*="custom.badge"]');
    var badgeFilterApplied = false;

    // COLOR FILTER   
    if (colorFilterInputs.length > 0) {

      var selectedColors = [];

      colorFilterInputs.forEach(input => {
        // console.log(input);
        if (input.checked) {
          selectedColors.push(input.value);
        }
      });

      // console.log(selectedColors);

      if (selectedColors.length > 0) {
        colorFilterApplied = true;

        productArray.forEach(function (product) {
          var hasAvailableSize = false;
          var sizeSelectors = product.querySelectorAll('form[action="/cart/add"]');

          selectedColors.forEach(selColor => {
            var productColorValue = product.getAttribute('data-color-filter');

            if (productColorValue === selColor && !filteredProducts.includes(product)) {

              sizeSelectors.forEach(selector => {
                if (selector.classList.contains('disabled')) {
                  selector.remove();
                } else {
                  hasAvailableSize = true;
                }
              });

              if (hasAvailableSize) {
                filteredProducts.push(product);
              } else {
                product.remove();
              };
            }

          });

        });

      }

    }

    // console.log(filteredProducts);

    // SIZE FILTER
    if (sizeFilterInputs.length > 0) {

      var selectedSizes = [];

      sizeFilterInputs.forEach(input => {
        if (input.checked) {
          selectedSizes.push(input.getAttribute('value'));
        }
      });

      // Sizes for "+" group
      if (selectedSizes.includes('+')) {

        const plus_sizes = [
          "10", "10-40", "10/11", "10M", "10W", "9", "11", "11M", "12", "12-18m", "12-18M", "12M", "13", "13M", "6", "14",
          "18-24m", "18-24M", "2/3", "24-36m", "24-36M", "5", "25", "27", "29", "3-6m", "3-6M", "36/XL", "7", "38", "38/XXL",
          "4", "4/5", "40", "42", "44", "46", "48", "50", "5W", "6-12m", "6-12M", "6/7", "6W", "7/8", "7M", "7W", "8", "8-38",
          "8-41", "8/9", "8M", "8W", "9-39", "9-42", "9M", "9W", "9W/8M"
        ];

        selectedSizes.push(...plus_sizes);
        
      }      

      if (selectedSizes.length > 0 || document.body.id == "archive-industry-of-all-nations" ) {
        sizeFilterApplied = true;

        // IF THERE WAS ALSO A COLOR FILTER APPLIED, EVEN WITH NO RESULTS
        if (colorFilterApplied) {
          productArray = filteredProducts;
          filteredProducts = [];
        }

        if (productArray.length > 0) {
          productArray.forEach(function (product) {
            // console.log(product);
            var hasAvailableSize = false;
            var sizeSelectors = product.querySelectorAll('form[action="/cart/add"]');

            sizeSelectors.forEach(selector => {
              // console.log(selector);
              if (!selector.classList.contains('collection-final-card')) {
                var sizeInputValue = selector.querySelector('input[type="submit"]').value;
                // console.log(sizeInputValue);
                if (selector.classList.contains('collection-cart-btn__one-variant')) {
                  hasAvailableSize = true;
                } else if ((selectedSizes.length > 0 && !selectedSizes.includes(sizeInputValue)) || selector.classList.contains('disabled')) {
                  selector.remove();
                } else {
                  hasAvailableSize = true;
                }
              }

            });

            if (hasAvailableSize && !filteredProducts.includes(product)) {
              filteredProducts.push(product);
            }

            if (!hasAvailableSize) {
              product.remove();
            }
          });
        }
      }

    }

    // SIZE FILTER
    if (badgeFilterInputs.length > 0) {

      var selectedBadges = [];

      badgeFilterInputs.forEach(input => {
        if (input.checked) {
          selectedBadges.push(input.getAttribute('value'));
        }
      });

      if (selectedBadges.length > 0) {

        badgeFilterApplied = true;

        // IF THERE WAS ALSO A COLOR OR SIZE FILTER APPLIED, EVEN WITH NO RESULTS
        if (colorFilterApplied || sizeFilterApplied) {
          productArray = filteredProducts;
          filteredProducts = [];
        }

        if (productArray.length > 0) {

          productArray.forEach(function (product) {
            var hasAvailableSize = false;
            var sizeSelectors = product.querySelectorAll('form[action="/cart/add"]');

            selectedBadges.forEach(selBadge => {
              var productBadgeValue = product.getAttribute('data-badge');

              if (productBadgeValue === selBadge && !filteredProducts.includes(product)) {

                sizeSelectors.forEach(selector => {
                  if (selector.classList.contains('disabled')) {
                    selector.remove();
                  } else {
                    hasAvailableSize = true;
                  }
                });

                if (hasAvailableSize) {
                  filteredProducts.push(product);
                } else {
                  product.remove();
                };
              }

            });

          });

        }
      }

    }

    // END FILTERS

    if (filteredProducts.length > 0) {
      productContainer.innerHTML = '';
      filteredProducts.forEach(function (product) {
        productContainer.appendChild(product);
      });
    } else if (filteredProducts.length == 0 && (colorFilterApplied || sizeFilterApplied)) {
      productContainer.innerHTML = '<div class="m-4">No results were found. Please try a different filter.</div>';
    }
  }

  static resetMiniaturesListeners() {

    var sliders = document.querySelectorAll('.slider-clp-images');

    if (sliders.length > 0) {

      sliders.forEach(function (slider) {
        var sliderPagination = slider.querySelector('.swiper-pagination');
        var sliderNextButton = slider.querySelector('.swiper-button-next');
        var sliderPrevButton = slider.querySelector('.swiper-button-prev');

        var CLPslider = new Swiper(slider, {
          loop: true,
          slidesPerView: 1,
          pagination: {
            el: sliderPagination,
            clickable: true
          },
          navigation: {
            nextEl: sliderNextButton,
            prevEl: sliderPrevButton
          },
          spaceBetween: 1,
        });

        var slidesLength = CLPslider.slides.length;
        slider.classList.add('slides-number-' + slidesLength);
      });
    }

    var variants = document.querySelectorAll('.collection-cart-btn__variants.available');

    if (variants.length > 0) {
      variants.forEach(variant => {
        variant.addEventListener('submit', function (event) {
          event.preventDefault();
          event.stopPropagation();

          const variantID = this.querySelector('input[name="id"]').value;
          // console.log(variantID);
          FacetFiltersForm.addToCart(variantID, 1);

        });
      });

    }

  }

  static addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      })
    }).then(response => {
      if (!response.ok) {
        throw new Error();
      }
      return response.json();
    });
  }

  static slideToSwiperImageInner(index) {

    var imageSwitcherFirst = document.querySelector('.image-switcher-container .first-image-selector');
    var imageSwitcherSecond = document.querySelector('.image-switcher-container .second-image-selector');

    if (index == 0) {
      imageSwitcherFirst.classList.add('picked');
      imageSwitcherSecond.classList.remove('picked');
    } else if (index == 1) {
      imageSwitcherSecond.classList.add('picked');
      imageSwitcherFirst.classList.remove('picked');
    }

    var sliders = document.querySelectorAll('.slider-clp-images');

    if (sliders.length > 0 && (index == 0 || index == 1)) {

      sliders.forEach(function (slider) {
        if (slider.swiper) {
          slider.swiper.slideTo(index);
        }
      });

    }

    var paginationLinks = document.querySelectorAll('.pagination a');

    if (paginationLinks.length > 0 && (index == 0 || index == 1)) {
      paginationLinks.forEach(function (link) {
        var url = new URL(link.href);
        url.searchParams.set('image', index);
        link.href = url.toString();
      });
    }

  }
}



var urlParams = new URLSearchParams(window.location.search);
var sortBy = urlParams.get('sort_by');

if (sortBy) {
  FacetFiltersForm.customSorting(sortBy);
}

FacetFiltersForm.customFiltering();

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

function closeDrawers() {
  var filterDrawer = document.querySelector('menu-drawer > details.menu-opening');
  if (filterDrawer) {
    filterDrawer.querySelector('summary').click();
  }
}

// var drawerBackgrounds = document.querySelectorAll('.facets-background');

// drawerBackgrounds.forEach((element) => {
//   element.addEventListener('click', closeDrawers);
// });

// SORTING IN PANEL
var sortSelectOptions = document.querySelectorAll(".options-group label");

if (sortSelectOptions) {

  sortSelectOptions.forEach(label => {

    label.addEventListener('click', function () {

      sortSelectOptions.forEach(eachLabel => {
        eachLabel.classList.remove('selected');
      });

      label.classList.add('selected');
      var sortSelect = document.querySelector("#FacetSortDrawerForm select");
      var sortForm = document.querySelector("#FacetSortDrawerForm");
      var value = label.getAttribute("data-value");

      Array.from(sortSelect.options).forEach(option => {
        if (option.value === value) {
          sortSelect.value = value;
        }
      });

      sortForm.dispatchEvent(new Event("input"));

    });
  });

  // SELECT FIRST SORTING OPTION TO "REMOVE" SORTING
  var removeSortBtn = document.querySelector('.remove-sorting');

  if (removeSortBtn) {

    removeSortBtn.addEventListener('click', function (e) {      
      e.preventDefault();

      var sortSelect = document.querySelector("#FacetSortDrawerForm select");
      var sortForm = document.querySelector("#FacetSortDrawerForm");

      sortSelect.value = sortSelect.options[0].value;

      sortForm.dispatchEvent(new Event("input"));

      document.querySelectorAll(".options-group label").forEach(label => {
        label.classList.remove('selected');
      });

    });
  }

}

function slideToSwiperImage(index) {

  var sliders = document.querySelectorAll('.slider-clp-images');

  if (sliders.length > 0) {

    sliders.forEach(function (slider) {
      if (slider.swiper) {
        slider.swiper.slideTo(index);
      }
    });

  }
}

var imageSwitcherSecond = document.querySelector('.image-switcher-container .second-image-selector');
var imageSwitcherFirst = document.querySelector('.image-switcher-container .first-image-selector');
const sortOptionsBtn = document.querySelector('#FacetSortDrawerForm');
const sortCloseBtn = document.querySelector('.sort_close');

function handleImageSwitcherClick(clickedElement, otherElement, slideIndex) {
  const url = new URL(window.location.href);

  if (clickedElement.classList.contains('picked')) {
    clickedElement.classList.remove('picked');
    slideToSwiperImage(0);
    url.searchParams.delete('image');
    togglePaginationLinkImageParams(false);
  } else {
    clickedElement.classList.add('picked');
    otherElement.classList.remove('picked');
    slideToSwiperImage(slideIndex);
    url.searchParams.set('image', slideIndex);
    togglePaginationLinkImageParams(true, slideIndex);
  }

  history.replaceState(null, '', url);

  closeDrawers();
  sortOptionsBtn.classList.remove('open');

}

imageSwitcherFirst.addEventListener('click', () => handleImageSwitcherClick(imageSwitcherFirst, imageSwitcherSecond, 0));
imageSwitcherSecond.addEventListener('click', () => handleImageSwitcherClick(imageSwitcherSecond, imageSwitcherFirst, 1));

const toggleContainer = document.querySelector('.image-switcher-container .toggle');

toggleContainer.addEventListener('click', function () {
  imageSwitcherSecond = document.querySelector('.image-switcher-container .second-image-selector');
  imageSwitcherFirst = document.querySelector('.image-switcher-container .first-image-selector');
  if (imageSwitcherSecond.classList.contains('picked')) {
    handleImageSwitcherClick(imageSwitcherFirst, imageSwitcherSecond, 0);
  } else {
    handleImageSwitcherClick(imageSwitcherSecond, imageSwitcherFirst, 1);
  }

});

document.addEventListener('DOMContentLoaded', function () {

  var urlParams = new URLSearchParams(window.location.search);
  var productImagePicker = urlParams.get('image');

  if (productImagePicker) {
    // console.log(productImagePicker);
    if (productImagePicker == 0) {
      handleImageSwitcherClick(imageSwitcherFirst, imageSwitcherSecond, 0);
    } else if (productImagePicker == 1) {
      handleImageSwitcherClick(imageSwitcherSecond, imageSwitcherFirst, 1);
    }

  }

});

function togglePaginationLinkImageParams(set, value) {

  var paginationLinks = document.querySelectorAll('.pagination a');

  if (paginationLinks.length > 0) {
    paginationLinks.forEach(function (link) {
      var url = new URL(link.href);
      if (!set) {
        url.searchParams.delete('image');
      } else {
        url.searchParams.set('image', value);
      }

      link.href = url.toString();
    });
  }
}


sortOptionsBtn.addEventListener('click', function () {
  sortOptionsBtn.classList.toggle('open');
  closeDrawers();
  // imageSwitcherFirst.classList.remove('picked');
  // imageSwitcherSecond.classList.remove('picked');
});

sortCloseBtn.addEventListener('click', function () {
  sortOptionsBtn.classList.toggle('open');
});

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}